<div class="app-footer sm:px-0 pt-20">
  <div class="mx:py-2.5">
    <div class="mx:flex mx:justify-between sm:pt-12">
      <div class="app-footer__share-text sm:mb-4">
        <div class="mx:text-[32px] sm:text-[24px]">
          {{ "INVENTED_FOR_LIFE" | translate }}
        </div>
        <div class="app-footer__links sm:block mx:flex">
          <div
            class="app-footer__links-language gap-x-2 items-center sm:pb-8 leading-relaxed"
          >
            <svg-icon [iconName]="'new/globe.svg'" [size]="24"></svg-icon>
            <div class="text-[16px] pt-1">Bosch Global</div>
            <div class="link-box">
              <nz-select
                [ngModel]="language"
                [nzDropdownMatchSelectWidth]="false"
                nzSize="small"
                class="language-setting"
                [nzSuffixIcon]="nzSuffixIcon"
                (ngModelChange)="changeLanguage()"
              >
                <ng-template #nzSuffixIcon>
                  <svg-icon
                    [iconName]="'new/arrow-down.svg'"
                    [size]="24"
                  ></svg-icon>
                </ng-template>
                <nz-option nzValue="en" nzLabel="EN"></nz-option>
                <nz-option nzValue="zh" nzLabel="中文"></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center text-center">
        <div class="px-10">
          <img
            class="mx:w-36 sm:w-[125px] inline-block mb-2"
            src="assets/images/mobility_aftermarket.jpg"
            alt=""
          />
          <div class="mx:w-36 sm:w-[125px] mx:text-[18px] sm:text-[14px]">
            {{ "FOOTER_ORDER" | translate }}
          </div>
        </div>
        <div class="px-10" *ngIf="country=='/iam'">
          <img
            class="mx:w-36 sm:w-[125px] inline-block mb-2"
            src="assets/images/1210_BCP_WEB.jpg"
            alt=""
          />
          <div
            class="mx:w-36 sm:w-[125px] mx:text-[18px] sm:text-[14px] text-center px-5"
          >
            {{ "FOOTER_eXtra" | translate }}
          </div>
        </div>
      </div>
    </div>
    <ul class="app-footer__terms sm:block mx:flex py-5 mt-8">
      <li class="terms-item">{{ "COMPANY_NAME_DETAIL_FOOTER" | translate }}</li>
      <li class="terms-item">
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action"
          >沪ICP备2020030684号-2</a
        >
      </li>
      <li class="terms-item">
        <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch"
          >沪公网安备31010502007521号</a
        >
      </li>
      <li
        class="terms-item"
        (click)="handleViewPrivacy('/myAccount/user-terms')"
      >
        {{ "PRIVACY_TERMS_OF_USE" | translate }}
      </li>
      <li
        class="terms-item"
        (click)="handleViewPrivacy('/myAccount/data-protection-policy', 0)"
      >
        {{ "CORPORATE" | translate }}
      </li>
      <li
        class="terms-item"
        (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)"
      >
        {{ "Data_PROTECTION_POLICY" | translate }}
      </li>
      <li
        class="terms-item"
        aria-label="Privacy settings"
        (click)="showDockPrivacySettings()"
      >
        {{ "PRIVACY_SETTINGS" | translate }}
      </li>
      <!-- <li class="terms-item" (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)">{{ "PRIVACY_STATEMENT" | translate }}</li> -->
    </ul>
  </div>
</div>
